import { useEffect, useMemo } from "react";
import { useStores } from "../../stores/root-store";
import { observer } from "mobx-react";
import _ from "lodash";
import {
  getDisplayVehicleType,
  ShowAlert,
  showConfirmationDialog,
} from "../../utils/functions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";

const cols: string[] = [
  "#",
  "Name",
  "Contact Number(s)",
  "Vechicle",
  "Actions",
];

const DriverListing = observer(() => {
  const { deliveryStore } = useStores();
  const { drivers, fetchDrivers, setEditDriver, deleteDriver } = deliveryStore;

  useEffect(() => {
    fetchDrivers();
  }, []);

  const driversList = useMemo(() => {
    return drivers;
  }, [drivers]);

  const handleDelete = (driverId: number) => {
    showConfirmationDialog(() => {
      deleteDriver(driverId, (res: boolean) => {
        if (res) {
          ShowAlert.Success("Driver deleted successfully.");
          fetchDrivers();
        } else ShowAlert.Error("Request failed. Please try again.");
      });
    });
  };

  return (
    <table className="table table-responsive table-striped shadow-lg">
      <thead>
        <tr>
          {cols.map((c, i) => (
            <th
              scope="col"
              className="border-top-0 border-start-0 border-end-0 border-3 border-warning"
              key={i}
            >
              {c}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {driversList?.map((driver, i) => {
          const vehType = getDisplayVehicleType(driver.vehicleType);
          return (
            <tr key={i}>
              <th scope="row">{i + 1}</th>
              <td>{driver.name}</td>
              <td>{`${driver.contactNumber}${
                driver.altContactNumber ? ", " + driver.altContactNumber : ""
              }`}</td>
              <td>
                <i className={vehType.cssClass}></i> {driver.vehicleRegNumber}
              </td>
              <td>
                <div className="btn-group">
                  <button className="btn" onClick={() => setEditDriver(driver)}>
                    <FontAwesomeIcon icon={faEdit} className="text-primary" />
                  </button>
                  <button
                    className="btn"
                    onClick={() => handleDelete(driver.deliveryDriverId)}
                  >
                    <FontAwesomeIcon icon={faTrash} className="text-danger" />
                  </button>
                </div>
              </td>
            </tr>
          );
        })}
        {!driversList?.length && (
          <tr>
            <th colSpan={5} className="text-center">
              No data available.
            </th>
          </tr>
        )}
      </tbody>
    </table>
  );
});

export default DriverListing;
